import React from 'react';
import { motion } from 'framer-motion';

export default function PremiumButton({ children, primary, large, icon, onClick }) {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.05, boxShadow: primary ? '0 20px 40px rgba(14,165,233,0.4)' : '0 20px 40px rgba(249,115,22,0.25)' }}
      whileTap={{ scale: 0.95 }}
      className={`
        relative group flex items-center justify-center gap-3 font-bold tracking-wide
        rounded-full overflow-hidden transition-all duration-300 shadow-xl backdrop-blur-sm
        ${large ? 'px-10 py-5 text-lg' : 'px-8 py-4 text-base'}
        ${primary
          ? 'bg-gradient-to-r from-cyan-500 via-blue-600 to-cyan-500 text-white'
          : 'bg-transparent border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10'}
      `}
    >
      {/* Pulse ring */}
      <motion.div
        animate={{ scale: [1, 1.3, 1], opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 2, repeat: Infinity }}
        className={`absolute inset-0 rounded-full blur-2xl opacity-30 ${primary ? 'bg-cyan-400' : 'bg-orange-400'}`}
      />
      {/* Shine */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
        initial={{ x: '-100%' }}
        whileHover={{ x: '100%' }}
        transition={{ duration: 0.6 }}
      />
      <span className="relative z-10 flex items-center gap-3">
        {children}
        {icon && <span className="text-xl">{icon}</span>}
      </span>
    </motion.button>
  );
}
